import React, { PureComponent } from 'react';

interface Props {
    size?: number;
}

class InventorySVG extends PureComponent<Props> {

    render() {
        const { size } = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 17 12" preserveAspectRatio="xMidYMid" style={{ fontSize: `${size}rem` }}  >
            <path fillRule="evenodd" clipRule="evenodd" d="M15.323 6.9255H13.2076H12.3615H11.0922V11.1563H15.323V6.9255ZM10.2461 6.07935V12.0024H16.1692V6.07935H10.2461Z" fill="currentColor"/>
            <path d="M12.7842 6.92554H13.6303V7.77169H12.7842V6.92554Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M10.4002 6.9255H8.28478H7.43863H6.1694V11.1563H10.4002V6.9255ZM5.32324 6.07935V12.0024H11.2463V6.07935H5.32324Z" fill="currentColor"/>
            <path d="M7.86133 6.92554H8.70748V7.77169H7.86133V6.92554Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.47731 6.9255H3.36193H2.51578H1.24654V11.1563H5.47731V6.9255ZM0.400391 6.07935V12.0024H6.32347V6.07935H0.400391Z" fill="currentColor"/>
            <path d="M2.93848 6.92554H3.78463V7.77169H2.93848V6.92554Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12.8621 2.0024H10.7467H9.90054H8.63131V6.23317H12.8621V2.0024ZM7.78516 1.15625V7.07933H13.7082V1.15625H7.78516Z" fill="currentColor"/>
            <path d="M10.3232 2.00244H11.1694V2.8486H10.3232V2.00244Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M7.93923 2.0024H5.82384H4.97769H3.70846V6.23317H7.93923V2.0024ZM2.8623 1.15625V7.07933H8.78538V1.15625H2.8623Z" fill="currentColor"/>
            <path d="M5.40039 2.00244H6.24654V2.8486H5.40039V2.00244Z" fill="currentColor"/>
            </svg>
            
        );
    }
}

export default InventorySVG;